import '@/App.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PublicLayout } from '@/components/site/PublicLayout';
import { AdminLayout } from '@/components/admin/AdminLayout';
import HomePage from '@/pages/HomePage';
import SeasonListPage from '@/pages/SeasonListPage';
import SeasonDetailPage from '@/pages/SeasonDetailPage';
import FieldNotesListPage from '@/pages/FieldNotesListPage';
import FieldNoteDetailPage from '@/pages/FieldNoteDetailPage';
import RecapsListPage from '@/pages/RecapsListPage';
import RecapDetailPage from '@/pages/RecapDetailPage';
import AboutPage from '@/pages/AboutPage';
import NewsletterPage from '@/pages/NewsletterPage';
import ContactPage from '@/pages/ContactPage';
import GearPage from '@/pages/GearPage';
import PrivacyPage from '@/pages/PrivacyPage';
import TermsPage from '@/pages/TermsPage';
import AffiliateDisclosurePage from '@/pages/AffiliateDisclosurePage';
import NotFoundPage from '@/pages/NotFoundPage';
import AdminLoginPage from '@/pages/admin/AdminLoginPage';
import DashboardPage from '@/pages/admin/DashboardPage';
import SeasonEntriesAdminPage from '@/pages/admin/SeasonEntriesAdminPage';
import SeasonEditorPage from '@/pages/admin/SeasonEditorPage';
import FieldNotesAdminPage from '@/pages/admin/FieldNotesAdminPage';
import FieldNoteEditorPage from '@/pages/admin/FieldNoteEditorPage';
import FeaturedVideoPage from '@/pages/admin/FeaturedVideoPage';
import SiteConfigPage from '@/pages/admin/SiteConfigPage';
import SubscribersPage from '@/pages/admin/SubscribersPage';
import ContactInboxPage from '@/pages/admin/ContactInboxPage';
import RecapsAdminPage from '@/pages/admin/RecapsAdminPage';
import { auth } from '@/lib/api';
import { loadPlausible } from '@/lib/plausible';

function RequireAuth({ children }) {
  return auth.isAuthed() ? children : <Navigate to="/admin/login" replace />;
}

function App() {
  useEffect(() => {
    loadPlausible();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="season" element={<SeasonEntriesAdminPage />} />
            <Route path="season/new" element={<SeasonEditorPage />} />
            <Route path="season/:id" element={<SeasonEditorPage />} />
            <Route path="field-notes" element={<FieldNotesAdminPage />} />
            <Route path="field-notes/new" element={<FieldNoteEditorPage />} />
            <Route path="field-notes/:id" element={<FieldNoteEditorPage />} />
            <Route path="recaps" element={<RecapsAdminPage />} />
            <Route path="featured-video" element={<FeaturedVideoPage />} />
            <Route path="site-config" element={<SiteConfigPage />} />
            <Route path="subscribers" element={<SubscribersPage />} />
            <Route path="inbox" element={<ContactInboxPage />} />
          </Route>
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<HomePage />} />
            <Route path="season" element={<SeasonListPage />} />
            <Route path="season/:slug" element={<SeasonDetailPage />} />
            <Route path="field-notes" element={<FieldNotesListPage />} />
            <Route path="field-notes/:slug" element={<FieldNoteDetailPage />} />
            <Route path="recap" element={<RecapsListPage />} />
            <Route path="recap/:yearMonth" element={<RecapDetailPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="newsletter" element={<NewsletterPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="gear" element={<GearPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="affiliate-disclosure" element={<AffiliateDisclosurePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
